const REQUIRED_PARAMETERS = ["kvk","btw","street","housenumber","postalcode","city","website","email","tel"];

export function areRequiredParametersSet(parameters_obj) {
  if(parameters_obj === null) {
    return false;
  }
  var valid_required_parameters = true;
  for(var i=0;i<REQUIRED_PARAMETERS.length;i++) {
    var item = parameters_obj[REQUIRED_PARAMETERS[i]];
    if(item === undefined || item.trim() === "") {
      valid_required_parameters = false;
    }
  }
  return valid_required_parameters;
}

export function getRequiredParameters() {
  return REQUIRED_PARAMETERS;
}



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/modules/required_parameters.js
// module id = 283
// module chunks = 1